var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoAttendantsNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Auto-Attendants_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Auto-Attendants_Normal",
    clipPath: "url(#clip-Auto-Attendants_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Auto-Attendants",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_52",
    "data-name": "Subtraction 52",
    d: "M-198.671-775.33a13.241,13.241,0,0,1-9.426-3.906,13.253,13.253,0,0,1-3.9-9.429,13.253,13.253,0,0,1,3.9-9.429A13.243,13.243,0,0,1-198.671-802a13.243,13.243,0,0,1,9.426,3.905,13.253,13.253,0,0,1,3.9,9.429,13.264,13.264,0,0,1-1.083,5.285,5.441,5.441,0,0,0-2.6-.661,5.443,5.443,0,0,0-5.437,5.437,5.384,5.384,0,0,0,.557,2.4A13.293,13.293,0,0,1-198.671-775.33Zm4.352-21.633h0l-5.189.044a.476.476,0,0,0-.248.058,1.493,1.493,0,0,0-.612.9c-.006.019-.012.036-.016.054a.549.549,0,0,1-.029.083c-.972,2.284-2,5.04-2.689,7.191a.207.207,0,0,0-.03.087l-.012.037a1.32,1.32,0,0,0,.012,1.176.777.777,0,0,0,.643.321h1.242l-1.724,5.422a.216.216,0,0,0-.03.131.911.911,0,0,0,.337.789.839.839,0,0,0,.526.175l-.014-.014.015,0a1.007,1.007,0,0,0,.277-.042.557.557,0,0,0,.248-.161l8.243-9.237a.835.835,0,0,0,.2-.892.811.811,0,0,0-.745-.643h-1.929l2.294-4.063a.913.913,0,0,0,.073-.921.928.928,0,0,0-.818-.5h-.029Z",
    transform: "translate(212.553 802.583)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_51",
    "data-name": "Subtraction 51",
    d: "M-198.088-774.163a13.908,13.908,0,0,1-5.449-1.1,13.688,13.688,0,0,1-4.7-3.291,13.945,13.945,0,0,1,.632-19.683,13.852,13.852,0,0,1,9.515-3.76,13.906,13.906,0,0,1,5.447,1.1,13.788,13.788,0,0,1,4.712,3.29,13.874,13.874,0,0,1,3.009,4.981.611.611,0,0,1-.03.463.59.59,0,0,1-.346.3.615.615,0,0,1-.194.032.6.6,0,0,1-.572-.408,12.709,12.709,0,0,0-2.738-4.544,12.764,12.764,0,0,0-9.277-4.014,12.665,12.665,0,0,0-8.683,3.426,12.744,12.744,0,0,0-.587,17.968,12.644,12.644,0,0,0,8.861,4.018c.133,0,.27.006.406.006a12.66,12.66,0,0,0,4.5-.816,5.423,5.423,0,0,0,.536,1.092A13.9,13.9,0,0,1-198.088-774.163Zm12.744-8.307h0a5.434,5.434,0,0,0-1.067-.585,12.749,12.749,0,0,0,1-4.095.61.61,0,0,1,.594-.559l.054,0a.626.626,0,0,1,.422.22.58.58,0,0,1,.134.427,13.888,13.888,0,0,1-1.139,4.588Zm.57-6.4h-.044v-.014a.576.576,0,0,1-.584-.541c-.009-.145-.019-.213-.029-.28-.005-.035-.01-.07-.015-.114a.524.524,0,0,0-.019-.113c-.008-.035-.018-.075-.025-.121a.592.592,0,0,1,.5-.672.609.609,0,0,1,.082-.006.592.592,0,0,1,.59.5l.007.043a1.14,1.14,0,0,1,.022.175,3.242,3.242,0,0,1,.058.512.581.581,0,0,1-.142.433A.56.56,0,0,1-184.775-788.866Z",
    transform: "translate(212 802)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2090",
    "data-name": "Group 2090",
    transform: "translate(17.52 17.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4593",
    "data-name": "Path 4593",
    d: "M23.632,29.794a6.021,6.021,0,0,1-2.426-11.532,6.021,6.021,0,1,1,4.852,11.02A6.127,6.127,0,0,1,23.632,29.794Zm-.015-10.859A4.841,4.841,0,1,0,25.591,28.2a4.849,4.849,0,0,0-1.973-9.281Z",
    transform: "translate(-17.609 -17.749)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4594",
    "data-name": "Path 4594",
    d: "M23.011,23.608h-1.33l-.2.614h-1.1l1.359-3.742h1.2L24.3,24.222H23.2l-.2-.614Zm-.263-.789-.409-1.213-.395,1.213h.8Z",
    transform: "translate(1.19 1.467)",
    fill: "#6f8b8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoAttendantsNormal);
export default __webpack_public_path__ + "static/media/Auto_Attendants_Normal.1fe286857e7f29559bc25a959ec47c5a.svg";
export { ForwardRef as ReactComponent };